/*jslint node: true, browser: true, sub: true, todo: true*/
"use strict";

var ko = require("pli/knockout");
var pli = require("pli/forms");
var viewModelInit = require("pli/forms-viewmodel");


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Private
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//---------------------------------------
function resolveKeymapHandler(gridObservable, name) {
    /// <summary>
    /// Attempts to resolve the keymap handler
    /// on grid observable for name specified.
    /// </summary>

    // check grid observable
    var v = gridObservable[name];
    if (typeof v === "function") {
        return function simpleKeymapHandler() {
            v.apply(gridObservable, arguments);
            return false;
        };
    }

    return function keymapHandler() {
        // check grid observable value
        v = ko.isObservable(gridObservable)
            && ko.utils.unwrapObservable(gridObservable);
        if (v && typeof v[name] === "function") {
            v[name].apply(v, arguments);
            return false;
        }
    };

}

//---------------------------------------
function extendKeymap(gridPage, formPage, o) {
    /// <summary>
    /// Initializes standard keymap configuration for grid/form pages.
    /// Specify `keymapData` on either `gridPage` or `formPage` to
    /// overwrite/append to standard keymap entries.
    /// </summary>

    // extend keymap data.
    // TODO - remove exclusion for root form once keymap handling is rejiggered into ViewModelInit.js
    if (!(gridPage.form && gridPage.form.isRoot)) {
        gridPage.keymapData = ko.utils.extend({
            "Copy": resolveKeymapHandler(o, "copyItems"),
            "Link": resolveKeymapHandler(o, "linkItems"),
            "New": resolveKeymapHandler(o, "openNew")
        }, gridPage.keymapData);
    }

    // initialize form keymap
    formPage.keymapData = ko.utils.extend({
        "Back": resolveKeymapHandler(o, "closeCurrent"),
        "Delete": resolveKeymapHandler(o, "deleteAndCloseCurrent"),
        "NextSibling": resolveKeymapHandler(o, "openNext"),
        "Open": resolveKeymapHandler(o, "openTarget"),
        "PreviousSibling": resolveKeymapHandler(o, "openPrevious")
    }, formPage.keymapData);
}


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// ViewModelInit extensions
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
viewModelInit.standardFactoryCreatorFor = function standardFactoryCreatorFor(itemClass, itemAccessor, extraFactoriesProvider, extraFactoryFinalizer, gridEmbeddedOnForm) {
    /// <summary>Note: could be added to GridViewModel.js</summary>
    return function createGridViewModelFactoryFor(originalRootId) {
        var rootId = originalRootId;
        if (!gridEmbeddedOnForm) {
            rootId = originalRootId.concat("_", itemAccessor);
        }
        var parentPage = pli.forms.navigationPages[rootId],
            formId = (parentPage && parentPage.defaultChildFormId) || rootId.concat("_form"),
            childPage = pli.forms.navigationPages[formId],
            haveExtraFactoriesProvider = (typeof extraFactoriesProvider === "function");
        var newArguments = arguments;
        newArguments[0] = formId;
        var factory = viewModelInit.createGridViewModelFactory(
            ko.utils.extend(
                {
                    computeErrorsCount: viewModelInit.computeErrorsCount,
                    finalize: function finalizeGridViewModelFactory(rootObject) {
                        if (parentPage && childPage) {
                            var itemObservable = (ko.isObservable(rootObject)
                                ? ko.computed(function () { return ko.utils.unwrapObservable(rootObject)[itemAccessor]; })
                                : ko.observable(ko.utils.unwrapObservable(rootObject)[itemAccessor])
                            );
                            factory.initializeNavigation(
                                parentPage,
                                childPage,
                                itemObservable
                            );
                            extendKeymap(
                                parentPage,
                                childPage,
                                itemObservable
                            );
                        } else {
                            if (window.console && window.console.warn) { window.console.warn("Grid navigation init skipped because of missing navigation page:", { parentId: rootId, parentPage: parentPage, childId: formId, childPage: childPage }); }
                        }

                        if (typeof extraFactoryFinalizer === "function") {
                            extraFactoryFinalizer.call(factory, rootObject);
                        }

                        return (haveExtraFactoriesProvider
                            ? ko.computed(function () { return ko.utils.unwrapObservable(rootObject)[itemAccessor].current(); })
                            : null
                        );
                    },
                    secureAction: viewModelInit.secureAction,
                    checkForDependencies: viewModelInit.checkForDependencies
                },
                haveExtraFactoriesProvider ? extraFactoriesProvider.apply(rootId, newArguments) : null
            ),
            itemClass,
            null,
            2 // apiVersion
        );
        return factory;
    };
};


//-------------------------------------------
// TODO: rename to "completeFactories" to be
// compatible with current viewmodel vocabulary.
viewModelInit.finalizeFactories = function finalizeFactoriesRecursive(factories, rootObject) {
    /// <summary></summary>
    if (factories.hasOwnProperty("factories")) {
        factories = factories.factories;
    }
    var childObject = rootObject;
    if (typeof factories.finalize === "function") {
        childObject = factories.finalize(rootObject);
    }
    var name, childFactories;
    for (name in factories) {
        if (factories.hasOwnProperty(name)) {
            childFactories = factories[name];
            if (typeof childFactories === "object") {
                viewModelInit.finalizeFactories(childFactories, childObject);
            }
        }
    }
};


//-------------------------------------------
viewModelInit.assignKeymaps = function assignPageKeymaps() {
    /// <summary></summary>
    var key, page;
    for (key in pli.forms.navigationPages) {
        if (pli.forms.navigationPages.hasOwnProperty(key)) {
            page = pli.forms.navigationPages[key];
            if (page.keymapData) {
                if (!page.keymapData.hasOwnProperty("New")) { page.keymapData["New"] = false; } // block new (when not assigned)
                pli.keys.registerKeymap(key, page.keymapData);
                page.keymap = key;
                delete page.keymapData;
            }
        }
    }
};


//-------------------------------------------
viewModelInit.secureAction = function secureViewModelAction(action, context, isReadOnly) {
    /// <summary>
    /// Ensures an view-model action does not
    /// fire if the entity is read-only.
    /// </summary>
    /// <param name="action">The action to fire if allowed</param>
    /// <param name="context">The value of 'this' for the action</param>
    /// <param name="isReadOnly">Custom function used to determine whether action cannot execute</param>
    if (typeof action !== "function") { throw new Error("action must be a function"); }
    if (typeof isReadOnly === "function") {
        return function customSecuredAction() {
            if (isReadOnly() || pli.viewModel.extras.isReadOnly()) { return; }
            return action.apply(context, arguments);
        };
    }
    return function defaultSecuredAction() {
        if (pli.viewModel.extras.isReadOnly()) { return; }
        return action.apply(context, arguments);
    };
};


//-------------------------------------------
viewModelInit.checkForDependencies = function checkForDependencies() {
    var current = this.current(),
        dependencies = current.extras.dependencies && current.extras.dependencies(),
        message,
        index;

    if (dependencies && dependencies.indexOf && dependencies.length > 0) {
        message = "Cannot delete this item; it is used by";

        for (index = 0; index < dependencies.length && index < 3; index += 1) {
            message += (index === 0 ? " " : ", ") + dependencies[index];
        }

        message += (dependencies.length > 3 ? " and others." : ".");

        if (current.extras && current.extras.dependencyHint) {
            message += current.extras.dependencyHint;
        }

        pli.viewModel.extras.notificationMessage.show({
            title: "Cannot delete split",
            message: message
        });

        return true;
    }
};


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Exports
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
module.exports = viewModelInit;



//////////////////
// WEBPACK FOOTER
// ./app/document/viewModelInitExtensions.js
// module id = 532
// module chunks = 49